import axios, { AxiosInstance } from 'axios';
import Cookies from 'js-cookie';
import { setupAxiosInterceptor } from './AxiosInterceptor';
import { ClockworkContext } from '@/shared/contexts/Clockwork';

class Request {
    public static create = (timeout = 20000, accept = 'application/json', contentType = 'application/json') : AxiosInstance => {
        const token = typeof window !== 'undefined' ? Cookies.get('api_token') : null;

        const request = axios.create({
            baseURL: process.env.NEXT_PUBLIC_API_URL,
            timeout: timeout,
            withCredentials: true,
            headers: {
                'Accept': accept,
                'Content-Type': contentType,
                ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
            },
        });

        const debug = ClockworkContext.getClockwork();

        setupAxiosInterceptor(request, debug);

        return request;
    };
}

export default Request;
